import React from "react";

import SupportPageLayout from "./SupportPageLayout";
import { H3 } from "@/components/Typography";
import RxAccordion from "@/components/ui/display/RxAccordion";

const faqItems = [
  {
    title: "Career Accelerator (virtual programme)",
    content: [
      {
        title: "Who is Career Accelerator for?",
        content:
          "Women at all ages and stages who want to level up in their career. Whether you want to get a pay rise, step into a new position, or move in a different direction entirely, we give you the tools you need to put a plan-of-action in place supercharge your career.",
      },
      {
        title: "What happens if I miss a session?",
        content:
          "All sessions are recorded and so can be watched on-demand at a time that suits you. However, we encourage you to block out all dates for your group coaching sessions in advance, as this should be protected time (where possible) dedicated to investing in yourself and your career – so please honour that!",
      },
      {
        title: "Why are the sessions recorded?",
        content:
          "We know how busy life can get. So, all sessions are recorded to allow those who weren’t present to catch up and benefit from the shared learning experience. They give you the ability to review sessions and keep track of your conversations, goals, and actions. This allows all participants to relax into each session and not feel the pressure of constantly taking notes, which encourages more presence and sharing. They also help our coach and host facilitate assessment, planning, and evaluation of the group's progress.The recordings are not available for download and are deleted after the programme finishes.",
      },
      {
        title: "Is there a Coaching Agreement?",
        content:
          "Once you sign up for the programme, you will receive a pre-programme survey and coaching agreement. This ensures learners are prepared for the programme, clear on the boundaries of the coaching container and understand the rules that apply around confidentiality.",
      },
      {
        title: "Can I access the content after the course finishes?",
        content: (
          <>
            <p>
              Yes. Make sure to download the workbook when prompted at the start
              of each chapter. This contains all the information you need to
              complete the course content and is yours to work through at your
              own pace. Career Accelerator gives you unlimited access to the
              AllBright Digital*, during which you can watch the content at your
              leisure.
            </p>
            <small>
              *Length of time for unlimited access to AllBright Digital depends
              on which membership type has been purchased.
            </small>
          </>
        ),
      },
      {
        title: "What is the time commitment for this programme?",
        content: (
          <>
            The minimum time commitment for the programme is four hours per
            fortnight, this includes:
            <ul>
              <li>1 hour workbook learning</li>
              <li>1 - 1.5 hours fortnightly live group coaching</li>
              <li>1 - 2 hours integrating your learning</li>
            </ul>
            <p>
              If you want to dedicate more time to your journey, you will be
              provided with additional reading, resources, and recommended
              courses to further support your learning.
            </p>
          </>
        ),
      },
      {
        title: "Can I cancel my programme once it’s started?",
        content:
          "No. Career Accelerator spots are in high demand and so sadly, we cannot cancel your place once it has started.",
      },
      {
        title: "What is your refund policy?",
        content:
          "You can claim a full refund when cancelling within 14 days of payment, unless your course start date is within 14 days of payment.",
      },
    ],
  },
  {
    title: "Accelerate (in-person programme)",
    content: [
      {
        title: "Who is Accelerate for?",
        content: (
          <>
            <p>Women who join the programme typically...</p>
            <ul>
              <li>
                Desire a new direction that is more fulfilling and exciting.
              </li>
              <li>
                Know they can do it but want the support and guidance to smash
                it first time.
              </li>
              <li>
                Want to be held accountable and make real career change happen
                for them.
              </li>
              <li>
                Benefit from the support, psychological safety and shared
                experiences of likeminded women.
              </li>
              <li>
                Are ready for a new role, promotion or career pivot and want to
                make it happen.
              </li>
              <li>
                Feel it’s time to move to a leadership role or confirm their
                leadership style.
              </li>
              <li>
                Need the confidence to step forward with their career ambitions
                and choices.
              </li>
            </ul>
          </>
        ),
      },
      {
        title: "I have a question... who can I speak to?",
        content:
          "If you have a question about you club membership, please email membership@allbright.co, if you need help or have any questions relating to the Accelerate programme or learning material, please email academy@allbright.co",
      },
      {
        title: "What happens if I miss an in-person session?",
        content:
          "We encourage all members to protect the time allocated for their group coaching sessions as best as they can, as we sadly cannot re-organise or move members between cohorts (due to confidentiality and pacing) unless there are extenuating circumstances. All dates for Accelerate will be released as early as possible, and it is possible to delay the start date to a later cohort if necessary.",
      },
      {
        title: "Is there a Coaching Agreement?",
        content:
          "Once you sign up for the programme, you will receive a pre-programme survey and coaching agreement. This ensures learners are prepared for the programme, clear on the boundaries of the coaching container and understand the rules that apply around confidentiality.",
      },
      {
        title: "Can I access the content after the course finishes?",
        content:
          "Yes. Make sure to download the workbook when prompted at the start of each chapter. This contains all the information you need to complete the course content and is yours to work through at your own pace. Accelerate lasts approximately six months, so you will also have six months outside of this to continue using AllBright Townhouse.",
      },
      {
        title: "Do I receive a certificate or accreditation upon completion?",
        content:
          "Once you have completed the programme, you will receive a certificate alongside CPD accreditation to demonstrate your commitment to conscious and proactive learning in your career.",
      },
      {
        title: "Can I get my employer to sponsor my place on Accelerate?",
        content:
          "Yes! Up to 70% of our learners have their places sponsored or funded by their employer. Interested in how you can get your employer to fund yours (and others) spot on the programme? Email: academy@allbright.co",
      },
    ],
  },
  {
    title: "Elevate (in-person programme)",
    content: [
      {
        title: "Who is Elevate for?",
        content: (
          <>
            <p>Women who join the programme typically...</p>
            <ul>
              <li>
                Desire tailored, expert advice from other women with lived
                experience, knowledge and awareness.
              </li>
              <li>
                Are committed to deep personal and professional development in
                order to achieve a fulfilling and prosperous career.
              </li>
              <li>
                Want to be held accountable and make real career progress happen
                for them.
              </li>
              <li>
                Benefit from the support, psychological safety and shared
                experiences of likeminded women.
              </li>
              <li>
                Are ready to create a legacy in leadership – in a way that is
                purpose-drive, value-additive and authentic.
              </li>
              <li>
                Benefit from learning how to master difficult stakeholders,
                conflict and disruptive periods in business.
              </li>
              <li>
                Are curious about and/or embrace a growth mindset and lifelong
                learning.
              </li>
              <li>
                Feel they can make a meaningful impact in their respective
                fields and want that to be a natural next step.
              </li>
              <li>
                Need the confidence to step forward with their career ambitions
                and choices.
              </li>
              <li>
                Recognize the importance of work-life balance and well-being.
              </li>
              <li>
                Are determined to thrive, not just survive, in leadership.
              </li>
            </ul>
          </>
        ),
      },
      {
        title: "I have a question... who can I speak to?",
        content:
          "If you have a question about you club membership, please email membership@allbright.co, if you need help or have any questions relating to the Accelerate programme or learning material, please email academy@allbright.co",
      },
      {
        title: "What happens if I miss an in-person session?",
        content:
          "We encourage all members to protect the time allocated for their group coaching sessions as best as they can, as we sadly cannot re-organise or move members between cohorts (due to confidentiality and pacing) unless there are extenuating circumstances. All dates for Elevate will be released as early as possible, and it is possible to delay the start date to a later cohort if necessary.",
      },
      {
        title: "Is there an Onboarding Agreement?",
        content:
          "Once you sign up for the programme, you will receive a pre-programme survey and onboarding agreement. This ensures learners are prepared for the programme, clear on the boundaries of the coaching container and understand the rules that apply around confidentiality.",
      },
      {
        title: "Do I receive a certificate or accreditation upon completion?",
        content:
          "Once you have completed the programme, you will receive a certificate alongside CPD accreditation to demonstrate your commitment to conscious and proactive learning in your career.",
      },
      {
        title: "Can I get my employer to sponsor my place on Elevate?",
        content:
          "Yes! Up to 70% of our learners have their places sponsored or funded by their employer. Interested in how you can get your employer to fund yours (and others) spot on the programme? Email: academy@allbright.co",
      },
      {
        title:
          "Do I get to choose a coach for group coaching and 1-2-1 sessions?",
        content:
          "For 1-2-1 coaching sessions, yes! We will send you a curated shortlist of AllBright’s legendary coaching faculty for women in leadership. From this, you can book a chemistry call with whoever takes your interest, and make your final decision from there. As for group coaching, each cohort will be automatically allocated a coach from this shortlist to lead all six group coaching sessions across the year.",
      },
    ],
  },
];

const SupportLearning: React.FC = (): JSX.Element => {
  return (
    <SupportPageLayout>
      {faqItems.map((faqs) => (
        <div style={{ padding: "30px 0 0 0" }} key={faqs.title}>
          <H3>{faqs.title}</H3>
          <RxAccordion items={faqs.content} />
        </div>
      ))}
    </SupportPageLayout>
  );
};

export default SupportLearning;
